/**
 * The UDA mark of an institutional (catalogue) research line: a shield with a crossed pick and mallet. It marks the
 * "Líneas de investigación UDA" title (brand colour), the institutional rows of the sidebars and of the lines modal
 * (grey) and the print export.
 *
 * Drawn with `currentColor`, so the caller sets the colour through `className`. Decorative (`aria-hidden`): the
 * meaning is told by the section title and by the row's hidden text.
 *
 * `trazo` sets the stroke of the outline and handles (1.8 by default). Bigger renders want a finer stroke: the tooltip
 * header draws it at 20px with 1.6, so the lines keep about the same real thickness and the curves look smoother.
 */
export function EscudoUda({ size = 18, className, trazo = 1.8 }: { size?: number; className?: string; trazo?: number }) {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			width={size}
			height={size}
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			aria-hidden="true"
			focusable="false"
		>
			<path d="M2 5 Q12 1 22 5 Q21.5 14 12 22.5 Q2.5 14 2 5Z" strokeWidth={trazo} strokeLinejoin="bevel" />
			<path d="M9.4 8.2l5.2 5.4M14.6 8.2l-5.2 5.4" strokeWidth={trazo} />
			<g fill="currentColor" stroke="none">
				<rect x={-1.8} y={-1} width={3.6} height={2} rx={0.35} transform="translate(9.2 8) rotate(-45)" />
				<rect x={-1.8} y={-1} width={3.6} height={2} rx={0.35} transform="translate(14.8 8) rotate(45)" />
			</g>
		</svg>
	);
}
